<!--  -->
<template>
  <div class="add_watermark">
    <div class="container2">
      <div class="title">开户凭证</div>
      <div style="text-align: right">
        <img id="tiao" style="width: 200px; height: 80px" />
      </div>
      <table cellspacing="0" cellpadding="0">
        <tr>
          <td class="question">用户名</td>
          <td class="answer">{{ info.userName }}</td>
        </tr>
        <tr>
          <td class="question">用户登录账户</td>
          <td class="answer">{{ info.loginCode }}</td>
        </tr>
        <tr>
          <td class="question">统一社会信用代码</td>
          <td class="answer">{{ info.blNum }}</td>
        </tr>
        <tr>
          <td class="question">开户银行</td>
          <td class="answer">{{ info.name_of_collection_account }}</td>
        </tr>
        <tr>
          <td class="question">企业名称</td>
          <td class="answer">{{ info.enterpriseName }}</td>
        </tr>
        <tr>
          <td class="question">代征账户名</td>
          <td class="answer">{{ info.opening_bank_name }}</td>
        </tr>
        <tr>
          <td class="question">企业账户</td>
          <td class="answer">{{ info.carNum }}</td>
        </tr>
        <!--<tr>
          <td class="question">企业结算账户</td>
          <td class="answer"></td>
        </tr>-->
        <tr>
          <td class="question">开启时间</td>
          <td class="answer">{{ info.addBankCarTime }}</td>
        </tr>
        <tr>
          <td style="height: 138px; text-align: center" colspan="2">
            <div ref="qrcodeDiv" style="width: 120px; height: 120px; margin: auto"></div>
          </td>
        </tr>
      </table>
      <div class="con_footer">
        <div class="">
          <i></i>
          <span>中资云企业综合服务平台</span>
        </div>
        <div style="float: right">
          <span>企业服务网站：</span>
          <em>{{ info.kyw_url }}</em>
        </div>
      </div>
      <p style="font-size: 8px; color: #505050; text-align: right">1/1</p>
    </div>
    <div class="div-button" id="buttonDiv">
      <button @click="print" class="bt-btm">打印</button>
    </div>
  </div>
</template>

<script>
import JsBarcode from "jsbarcode";
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      info: {},
      session: "",
    };
  },
  methods: {
    getInfo() {
      let session;
      if (!this.session) {
        session = JSON.parse(localStorage["session"]);
      } else {
        session = this.session;
      }
      let data = {
        sessionId: session.sessionId,
        userId: session.userId,
        enterpriseId: session.enterpriseId,
        modeCode: "2aMyFOEDoMwcn5QRdVfLaf23EkPgwpgF",
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.info = res.data.voucher;
          this.barCode();
          this.generateQRCode();
        } else {
          this.$Message["error"]({
            background: true,
            content: res.msg,
          });
        }
      });
    },
    barCode() {
      JsBarcode("#tiao", this.info.carNum, {
        format: "CODE128", //选择要使用的条形码类型
        width: 3, //设置条之间的宽度
        height: 80, //高度
        displayValue: true, //是否在条形码下方显示文字
        text: this.info.carNum, //覆盖显示的文本
        // fontOptions: "bold italic", //使文字加粗体或变斜体
        font: "fantasy", //设置文本的字体
        textAlign: "center", //设置文本的水平对齐方式
        textPosition: "bottom", //设置文本的垂直位置
        textMargin: 5, //设置条形码和文本之间的间距
        fontSize: 24, //设置文本的大小
        margin: 15, //设置条形码周围的空白边距
      });
    },
    generateQRCode() {
	  let that = this
      let newSession = {};
      let session = JSON.parse(localStorage["session"]);
      newSession.sessionId = session.sessionId;
      newSession.userId = session.userId;
      newSession.enterpriseId = session.enterpriseId;
      this.$refs.qrcodeDiv.innerHTML = "";
      var qrcode = new QRCode(this.$refs.qrcodeDiv, {
        text: localStorage.getItem("platUrl")+'/#/' + "certificatePrint?session=" + encodeURI(JSON.stringify(newSession)), //二维码内容   url填后台给的链接
        width: 120, //控制二维码高度
        height: 120, //控制二维码宽度
        colorDark: "#000000", //控制二维码前景色
        colorLight: "#ffffff", //控制二维码背景色=
        correctLevel: QRCode.CorrectLevel.L, //设置二维码容错率
      });
    },
    print() {
      window.print();
      this.$router.back();
    },
  },
  mounted() {
    if (location.href.indexOf("?") != -1) {
      this.session = JSON.parse(decodeURIComponent(location.href.split("session=")[1]));
      this.getInfo();
    } else {
      this.getInfo();
    }
  },
};
</script>
<style lang="less" scoped>
@media print {
  .div-button {
    display: none;
  }
}
body,
header,
input,
footer,
div,
p,
ul,
li,
dl,
dt,
dd,
form,
h1,
h2,
h3,
h4,
h5,
span,
em,
i,
strong,
a,
hr,
table,
tr,
th,
td,
br,
label,
nav,
select,
img {
  padding: 0;
  margin: 0;
}

ul,
ol,
dl,
textarea {
  list-style: none;
}
textarea {
  outline: none;
}
a {
  color: #000;
  text-decoration: none;
}
input:focus,
button:focus,
select:focus {
  outline: none;
}
input {
  border: none;
}
em,
i {
  font-style: normal;
}
.clear {
  clear: both;
}
i {
  display: inline-block;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
b {
  font-weight: normal;
}
.add-pointer {
  cursor: pointer;
}
.add-middle {
  vertical-align: middle;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
.btnCss {
  display: inline-block;
  text-align: center;
  border-radius: 4px;
  cursor: pointer;
  color: #ffffff;
}
.clearFloat:after {
  display: block;
  clear: both;
  content: "";
  visibility: hidden;
  height: 0;
}
.clearFloat {
  zoom: 1;
}

body {
  font-family: SimHei, Arial;
}
.add_watermark {
  height: 100%;
  background-image: url("../assets/imgs/home/pingzheng_bg.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  box-sizing: border-box;
  padding-top: 66px;
}
.container2 {
  width: 470px;
  margin: auto;
}
.title {
  font-size: 22px;
  color: #505050;
  font-weight: 600;
  text-align: center;
  margin-bottom: 36px;
}
table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}
table,
td {
  border: 1px solid #505050;
}
table td {
  height: 40px;
  font-size: 12px;
  color: #505050;
}
table .question {
  width: 180px;
  text-align: center;
  font-weight: 600;
}
table .answer {
  width: 288px;
  box-sizing: border-box;
  padding-left: 10px;
}
.con_footer {
  color: #505050;
  overflow: hidden;
  margin-top: 10px;
  margin-bottom: 32px;
  padding: 0px 10px;
}
.con_footer span,
.con_footer em {
  display: inline-block;
  font-size: 10px;
  /*-webkit-transform: scale(0.8);*/
}
.con_footer i {
  width: 22px;
  height: 12px;
  background-image: url("../assets/imgs/home/comlogo.png");
  float: left;
  margin-right: 5px;
  margin-top: 3px;
}
.con_footer span,
.con_footer em {
  float: left;
}
.con_footer > div span {
  font-weight: 600;
}
.bt-btm {
  line-height: 30px;
  width: 200px;
  color: #ffffff;
  background-color: #2c59c3;
  border: 0;
  border-radius: 2px;
  font-size: 16px;
  cursor: pointer;
}
.div-button {
  text-align: center;
  margin-top: 16px;
}
.iconfont {
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
}
</style>
